import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";

interface IArrowProps {
  variant?: string;
  disabled?: boolean;
  justifyContent?: string;
}

const ButtonLinkStyles = css<IArrowProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  width: 100%;
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[4]};
  border: 0;
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.primaryYellow};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;

  ${(props) =>
    props.variant === "secondary" &&
    css`
      background: ${({ theme }) => theme.colors.primaryYellow};
      color: ${({ theme }) => theme.colors.primary};
    `}
`;

const StyledButtonLink = styled(Link)<IArrowProps>`
  ${ButtonLinkStyles}
`;

export const ButtonLinkCenter = styled.span`
  flex: 1;
  text-align: center;
`;

interface IProps {
  onClick?: () => void;
  to: string;
  children: React.ReactNode;
  variant?: string;
  disabled?: boolean;
  justifyContent?: string;
}

type Props = IProps;

const ButtonLink: React.FC<Props> = ({
  children,
  onClick,
  to,
  variant = "primary",
  disabled = false,
  justifyContent,
}) => (
  <StyledButtonLink
    to={to}
    onClick={onClick}
    variant={variant}
    disabled={disabled}
    justifyContent={justifyContent}
  >
    {children}
  </StyledButtonLink>
);

export default ButtonLink;
